var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],class:_vm.klass},[(_vm.icon)?_c('i',{staticClass:"fa",class:_vm.icon}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.customer.shipments_last_week))])])
}
var staticRenderFns = []

export { render, staticRenderFns }